import BlogDetailPage from "@/pages/blog/components/BlogDetailPage";

export default function BlogFlutterLaravel() {
  return <BlogDetailPage slug="building-flutter-apps-with-laravel-apis" />;
}